/** Базовый URL продакшена для canonical и Open Graph */
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://tex-mall.ru").replace(/\/$/, "")

export const SITE_NAME = "ТЕКС МОЛЛ"

/** Фрагмент <title> главной (в шаблоне SeoHelmet добавляется «| ТЕКС МОЛЛ») */
export const HOME_SEO_TITLE = "Ткани и мебельные материалы — каталог, самовывоз и доставка"

/** Meta description по умолчанию и для страниц без уникального текста (~150–170 знаков) */
export const DEFAULT_DESCRIPTION =
  "ТЕКС МОЛЛ — магазин тканей в Ростове-на-Дону и Ульяновске: обивочные и мебельные материалы, большой склад. Онлайн-каталог коллекций, самовывоз и доставка."

/**
 * Стабильный видимый текст на главной при загрузке/ошибке API.
 * Иначе бот видит только меню и служебные фразы — так и собирается «скудный» сниппет.
 */
export const HOME_VISIBLE_LEAD =
  "Интернет-магазин и шоурум тканей: коллекции для штор, обивки мебели и творчества. Работаем в Ростове-на-Дону (ул. Текучёва) и в Ульяновске — заходите в каталог или в шоурум."
